/**
 * RDT infringement levels.
 *
 * @readonly
 * @enum {string}
 */
export const RdtInfringementLevels = Object.freeze({
    MINOR: 'minor',
    SERIOUS: 'serious',
    VERY_SERIOUS: 'verySerious',
    MOST_SERIOUS: 'mostSerious'
})
